// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"9":"a2985f7e","23":"b4f996e9","255":"d5a12fb1","328":"8edaf04c","367":"8b80a77b","374":"0e5ff0f3","704":"2addc683","750":"3f0afe1d","781":"e6ee1537","857":"a9d28143","883":"7f380d61","943":"ab410a6a"}[chunkId] + ".chunk.js";
};